import { useQuery } from "@tanstack/react-query";
import { LCR_ORDER_QUERY_KEY } from "@/pages/OrderTracking/Lcr/lcr.constants";
import type { LcrOrder } from "@/services/orders/lcr-order.types";
import { LcrOrdersService } from "@/services/orders/lcr-orders-service";

let lcrOrdersService: LcrOrdersService | undefined;
const getLcrOrdersService = (): LcrOrdersService => (lcrOrdersService ??= new LcrOrdersService());

export const useLcrOrder = (serialNumber: string | undefined) =>
  useQuery<LcrOrder, Error>({
    queryKey: [LCR_ORDER_QUERY_KEY, serialNumber],
    queryFn: () => getLcrOrdersService().getLcrOrder(serialNumber as string),
    enabled: Boolean(serialNumber),
  });
